export interface LineItemPhotoSource {
  imagePreviewUrl?: string | null;
  imageUrl?: string | null;
}

/** Hydrated previews win; storage keys must never become relative image requests. */
export function lineItemPhotoSource(line: LineItemPhotoSource): string | null {
  for (const value of [line.imagePreviewUrl, line.imageUrl]) {
    const source = value?.trim();
    if (!source) continue;
    if (/^data:image\/[a-z0-9.+-]+[;,]/i.test(source)) return source;
    try {
      const url = new URL(source);
      if (url.protocol === 'https:' || url.protocol === 'http:') return source;
    } catch {
      // A catalog storage key needs a signed preview URL from the server.
    }
  }
  return null;
}
